export default __webpack_public_path__ + "static/media/slide7.b92959e6.png";